export default __webpack_public_path__ + "static/media/campaign-pause.5510a41a.svg";